import store from '@/store';
import decode from 'jwt-decode';
import multiguard from 'vue-router-multiguard';
import { hasAccess, isActive, ROLES_ACCESS } from '../utils';

const ifAuthenticatedAndDistributor = async (to, from, next) => {
  if (store.getters.isAuthenticated) {
    await store.dispatch(
      'get_user',
      decode(sessionStorage.getItem('access_token_4') || localStorage.getItem('access_token'))._id
    );
    if (store.getters.needToSetupUser) {
      next('/signup');
    } else if (store.getters.loggedInUser.distributorId) {
      next();
    } else {
      next('/');
    }
    return;
  }
  next('/signin');
};

const promoStandardsRoutes = [
  {
    path: '/promostandards',
    name: 'promostandards/index',
    meta: {
      id: ROLES_ACCESS.PROMOSTANDARDS
    },
    component: () => import('@/portals/PromoStandards/Index'),
    beforeEnter: multiguard([ifAuthenticatedAndDistributor, isActive, hasAccess]),
    children: [
      {
        path: 'my-account',
        name: 'promostandards/my-account',
        meta: { id: ROLES_ACCESS.PROMOSTANDARDS, available: true },
        component: () => import('@/portals/PromoStandards/MyAccount')
      },
      {
        path: 'my-account/change-password',
        name: 'promostandards/my-account/change-password',
        meta: { id: ROLES_ACCESS.PROMOSTANDARDS, available: true },
        component: () => import('@/portals/Application/MyAccount/ChangePassword')
      },
      {
        path: 'credentials',
        name: 'promostandards/credentials',
        meta: {
          id: ROLES_ACCESS.PROMOSTANDARDS
        },
        component: () => import('@/portals/PromoStandards/Credentials')
      },
      {
        path: 'endpoints',
        name: 'promostandards/endpoints',
        meta: {
          id: ROLES_ACCESS.PROMOSTANDARDS
        },
        component: () => import('@/portals/PromoStandards/Endpoints')
      },
      {
        path: 'explorer',
        name: 'promostandards/explorer',
        meta: {
          id: ROLES_ACCESS.PROMOSTANDARDS
        },
        component: () => import('@/portals/PromoStandards/Explorer')
      },
      {
        path: 'distributors',
        name: 'promostandards/distributors',
        meta: {
          id: ROLES_ACCESS.PROMOSTANDARDS
        },
        component: () => import('@/portals/PromoStandards/MyDistributor')
      },
      {
        path: 'users',
        name: 'promostandards/users',
        meta: {
          id: ROLES_ACCESS.PROMOSTANDARDS
        },
        component: () => import('@/components/UsersList')
      },
      {
        path: 'users/create',
        name: 'promostandards/users/create',
        meta: {
          id: ROLES_ACCESS.PROMOSTANDARDS
        },
        component: () => import('@/components/UserForm')
      },
      {
        path: 'users/:userId/edit',
        name: 'promostandards/users/:userId/edit',
        meta: {
          id: ROLES_ACCESS.PROMOSTANDARDS
        },
        component: () => import('@/components/UserForm')
      },
      {
        path: 'users/:userId/changepassword',
        name: 'promostandards/users/:userId/changepassword',
        meta: {
          id: ROLES_ACCESS.PROMOSTANDARDS
        },
        component: () => import('@/components/ChangePassword')
      }
    ].map((el) => ({ ...el, beforeEnter: hasAccess }))
  }
];

export { promoStandardsRoutes as default };
